import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_ARCHIVOS = 'ALL_ARCHIVOS';
export const LOADING_ALL_ARCHIVOS = 'LOADING_ALL_ARCHIVOS';
export const ACTIVO_ARCHIVOS = 'ACTIVO_ARCHIVOS';
export const ALERT_VIEW_ARCHIVOS = 'ALERT_VIEW_ARCHIVOS';
export const ALERT_FORM_ARCHIVOS = 'ALERT_FORM_ARCHIVOS';
export const PARAMS_ARCHIVOS = 'PARAMS_ARCHIVOS';
export const SEARCH_ARCHIVOS = 'SEARCH_ARCHIVOS';

const initialState = {
  all: [],
  loadingAll: false,
  search: [],
  activo: null,
  params: {},
  alertView: null,
  alertForm: null,
};

export const archivosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ARCHIVOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ARCHIVOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ARCHIVOS:
      return {
        ...state,
        activo: action.payload,
      };
    case ALERT_VIEW_ARCHIVOS:
      return {
        ...state,
        alertView: action.payload,
      };
    case ALERT_FORM_ARCHIVOS:
      return {
        ...state,
        alertForm: action.payload,
      };
    case SEARCH_ARCHIVOS:
      return {
        ...state,
        search: action.payload,
      };
    case PARAMS_ARCHIVOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
